import { Adresse } from '../../../../generated/model/adresse.model';
import { Address } from '@mwe/models';

export function mapUmmeldungAdresseToAddress(ummeldungAdresse: Adresse | null | undefined): Address | null {
  if (!ummeldungAdresse) {
    return null;
  }

  return {
    id: null,
    street: ummeldungAdresse.strasse ?? null,
    streetNumber: ummeldungAdresse.hausnummer ?? null,
    block: ummeldungAdresse.stiege ?? null,
    doorNumber: ummeldungAdresse.tuernummer ?? null,
    hint: null,
    postcode: ummeldungAdresse.plz ?? null,
    city: ummeldungAdresse.ort ?? null,
    country: null,
  };
}
